'use strict';

var axs = require('./axs');
var Box = axs()('div');
module.exports = Box;


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/Box.js
// module id = 27
// module chunks = 0